import { render, staticRenderFns } from "./integration_page.vue?vue&type=template&id=30c3060a&scoped=true&"
import script from "./integration_page.vue?vue&type=script&lang=js&"
export * from "./integration_page.vue?vue&type=script&lang=js&"
import style0 from "./integration_page.vue?vue&type=style&index=0&id=30c3060a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c3060a",
  null
  
)

export default component.exports